import NoDataComponent from "./../../../Table/TableComponents/NoDataComponent";
import React from "react";
import { MdPeople } from "react-icons/md";

const agent_attorney_no_data = props => {
  return (
    <NoDataComponent
      {...props}
      icon={<MdPeople size={60} className="noDataIcon" />}
      headerinfo="No Agents or Attorneys"
      subheaderinfo="Agents or Attorneys will appear here"
    />
  );
};

export default agent_attorney_no_data;